export const TIME_FORMAT = 'HH:mm';
export const DATE_FORMAT_SHORT = 'DD.MM.YY';
export const DATE_FORMAT_LONG_MINUTE = `DD.MM.YYYY ${TIME_FORMAT}`;
export const DATE_FORMAT_FULL = 'DD.MM.YYYY HH:mm:ss';
export const REQUIREMENTS_TEMPLATE_DATE_FORMAT = 'YYYY-MM-DD';
export const SYSTEM_DATE_FORMAT = 'YYYY-MM-DD';
export const SYSTEM_DATE_FORMAT_SHORT = 'YYYY-M-D-H-m';
export const DATE_FORMAT_ISO = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]';
export const DATE_FORMAT_ISO_DOT = 'YYYY.MM.DD';

export const DATE_FORMAT_LONG_FNS = 'dd.MM.yyyy';
export const DATE_FORMAT_FULL_FNS = 'dd.MM.yyyy HH:mm:ss';
export const DATE_FORMAT_SYSTEM_FULL_FNS = 'dd.MM.yyyy HH.mm.ss';
export const DATE_FORMAT_LONG_MINUTE_FNS = `dd.MM.yyyy HH:mm`;
export const SYSTEM_DATE_FORMAT_FNS = 'yyyy-MM-dd';
export const DATE_FORMAT_ISO_FNS = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'";
export const DATE_FORMAT_ISO_DOT_FNS = 'yyyy.MM.dd';
export const SYSTEM_DATE_FORMAT_SHORT_FNS = 'yyyy-M-d-H-m-s';
export const DATE_FORMAT_LONG_MINUTE_SHORT_FNS = 'yyyy-M-d-H-m';
export const DATE_FORMAT_SHORT_FNS = 'dd.MM.yy';
